module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " padding-left-30 padding-right-30 padding-bottom-30"
  }, [_c('div', {
    staticClass: "vctb-list"
  }, [_c('div', {
    staticClass: "vctb-item",
    class: {
      'vctb-item-active': _vm.vctbIndex == 0
    },
    on: {
      "click": function($event) {
        return _vm.clickvctb(0)
      }
    }
  }, [_vm._v("\n      专利 (" + _vm._s(_vm.com[1].totalnum) + ")\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "vctb-item",
    class: {
      'vctb-item-active': _vm.vctbIndex == 1
    },
    on: {
      "click": function($event) {
        return _vm.clickvctb(1)
      }
    }
  }, [_vm._v("\n      商标 (" + _vm._s(_vm.com[0].totalnum) + ")\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "vctb-item",
    class: {
      'vctb-item-active': _vm.vctbIndex == 2
    },
    on: {
      "click": function($event) {
        return _vm.clickvctb(2)
      }
    }
  }, [_vm._v("\n      软著 (" + _vm._s(_vm.com[2].totalnum) + ")\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "vctb-item",
    class: {
      'vctb-item-active': _vm.vctbIndex == 3
    },
    on: {
      "click": function($event) {
        return _vm.clickvctb(3)
      }
    }
  }, [_vm._v("\n      作品 (" + _vm._s(_vm.com[3].totalnum) + ")\n    ")])]), _vm._v(" "), (_vm.vctbIndex == 0) ? [_c('div', [_vm._m(0), _vm._v(" "), _vm._l((_vm.patent_list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "box5"
    }, [_c('div', {
      staticClass: "box5_text2  cpoint",
      on: {
        "click": function($event) {
          return _vm.toout(item.href)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.name ? item.name : "--") + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 "
    }, [_vm._v(_vm._s(item.date || '--'))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 "
    }, [_vm._v(_vm._s(item.number || '--'))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 "
    }, [_vm._v(_vm._s(item.public_number || '--'))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 "
    }, [_vm._v(_vm._s(item.status || '--'))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 "
    }, [_vm._v(_vm._s(item.cat || '--'))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 width-50",
      staticStyle: {
        "flex": "none"
      }
    }, [_c('span', {
      staticClass: "cpoint",
      staticStyle: {
        "color": "#0070c0"
      },
      on: {
        "click": function($event) {
          return _vm.showDialog(1, item)
        }
      }
    }, [_vm._v("详情")])])])
  }), _vm._v(" "), (!_vm.patent_list.length) ? _c('div', {
    staticClass: "padding-bottom-40"
  }, [_c('nomore')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.com[1].pagesize,
      "page-sizes": _vm.pageSizes,
      "hide-on-single-page": false,
      "layout": "prev, pager, next,sizes",
      "current-page": _vm.com[1].currentPage,
      "total": _vm.com[1].totalnum
    },
    on: {
      "size-change": function($event) {
        return _vm.handleSizeChange($event, 1)
      },
      "current-change": function($event) {
        return _vm.handleCurrentChange($event, 1)
      }
    }
  })], 1)], 2)] : (_vm.vctbIndex == 1) ? [_c('div', [_vm._m(1), _vm._v(" "), _vm._l((_vm.brand_list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "box5"
    }, [_c('div', {
      staticClass: "box5_text1 text-center"
    }, [_c('div', {
      staticClass: "response text-center"
    }, [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 text-center",
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(item.date || '--') + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 text-center",
      staticStyle: {
        "width": "15%"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "50px",
        "height": "auto"
      },
      attrs: {
        "src": _vm._f("addurl")(item.pic),
        "alt": "",
        "srcset": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 text-center cpoint",
      staticStyle: {
        "color": "#0070c0",
        "width": "30%"
      },
      on: {
        "click": function($event) {
          return _vm.toout(item.href)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.name || '--') + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 text-center",
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v("\n          " + _vm._s(item.register_num || '--') + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 text-center",
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(item.cat || '--') + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 text-center",
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v("\n          " + _vm._s(item.status || '--') + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 width-100",
      staticStyle: {
        "flex": "none"
      }
    }, [_c('span', {
      staticClass: "cpoint",
      staticStyle: {
        "color": "#0070c0"
      },
      on: {
        "click": function($event) {
          return _vm.showDialog(0, item)
        }
      }
    }, [_vm._v("详情")])])])
  }), _vm._v(" "), (!_vm.brand_list.length) ? _c('div', {
    staticClass: "padding-bottom-40"
  }, [_c('nomore')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.com[0].pagesize,
      "page-sizes": _vm.pageSizes,
      "hide-on-single-page": false,
      "layout": "prev, pager, next,sizes",
      "current-page": _vm.com[0].currentPage,
      "total": _vm.com[0].totalnum
    },
    on: {
      "size-change": function($event) {
        return _vm.handleSizeChange($event, 0)
      },
      "current-change": function($event) {
        return _vm.handleCurrentChange($event, 0)
      }
    }
  })], 1)], 2)] : (_vm.vctbIndex == 2) ? [_vm._m(2), _vm._v(" "), _c('div', [_vm._m(3), _vm._v(" "), _vm._l((_vm.softright_list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "box5"
    }, [_c('div', {
      staticClass: "box5_text1 text-center"
    }, [_c('div', {
      staticClass: "response text-center"
    }, [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 text-center"
    }, [_vm._v(_vm._s(item.complete_date))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 text-center cpoint",
      staticStyle: {
        "color": "#0070c0"
      }
    }, [_vm._v("\n          " + _vm._s(item.name ? item.name : "--") + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 text-center"
    }, [_vm._v("\n          " + _vm._s(item.introduce || '--') + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 text-center"
    }, [_vm._v("\n          " + _vm._s(item.register_num || '--') + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 text-center"
    }, [_vm._v(_vm._s(item.cat || '--'))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 text-center"
    }, [_vm._v(_vm._s(item.version || '--'))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 text-center"
    }, [_vm._v(_vm._s(item.fabiao_date || '--'))])])
  }), _vm._v(" "), (!_vm.softright_list.length) ? _c('div', {
    staticClass: "padding-bottom-40"
  }, [_c('nomore')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.com[2].pagesize,
      "page-sizes": _vm.pageSizes,
      "hide-on-single-page": false,
      "layout": "prev, pager, next,sizes",
      "current-page": _vm.com[2].currentPage,
      "total": _vm.com[2].totalnum
    },
    on: {
      "size-change": function($event) {
        return _vm.handleSizeChange($event, 0)
      },
      "current-change": function($event) {
        return _vm.handleCurrentChange($event, 2)
      }
    }
  })], 1)], 2)] : (_vm.vctbIndex == 3) ? [_vm._m(4), _vm._v(" "), _c('div', [_vm._m(5), _vm._v(" "), _vm._l((_vm.copyright_list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "box5"
    }, [_c('div', {
      staticClass: "box5_text1 text-center"
    }, [_c('div', {
      staticClass: "response text-center"
    }, [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 text-center cpoint",
      staticStyle: {
        "color": "#0070c0",
        "width": "22.5%"
      },
      on: {
        "click": function($event) {
          return _vm.toout(item.href)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.name ? item.name : "--") + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 text-center",
      staticStyle: {
        "width": "22.5%"
      }
    }, [_vm._v("\n          " + _vm._s(item.register_num || '--') + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 text-center",
      staticStyle: {
        "width": "22.5%"
      }
    }, [_vm._v("\n          " + _vm._s(item.cat || '--') + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 text-center",
      staticStyle: {
        "width": "22.5%"
      }
    }, [_vm._v("\n          " + _vm._s(item.complete_date || '--') + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 text-center",
      staticStyle: {
        "width": "22.5%"
      }
    }, [_vm._v("\n          " + _vm._s(item.date || '--') + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 text-center",
      staticStyle: {
        "width": "22.5%"
      }
    }, [_vm._v("\n          " + _vm._s(item.fabiao_date || '--') + "\n        ")])])
  }), _vm._v(" "), (!_vm.copyright_list.length) ? _c('div', {
    staticClass: "padding-bottom-40"
  }, [_c('nomore')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.com[3].pagesize,
      "page-sizes": _vm.pageSizes,
      "hide-on-single-page": false,
      "layout": "prev, pager, next,sizes",
      "current-page": _vm.com[3].currentPage,
      "total": _vm.com[3].totalnum
    },
    on: {
      "size-change": function($event) {
        return _vm.handleSizeChange($event, 0)
      },
      "current-change": function($event) {
        return _vm.handleCurrentChange($event, 3)
      }
    }
  })], 1)], 2)] : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "商标信息详情",
      "visible": _vm.dialogData[0].show
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogData[0], "show", $event)
      }
    }
  }, [(_vm.dialogData[0].showData) ? _c('div', {}, [_c('table', {
    staticClass: "pure-table pure-table-bordered"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("商标名称")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[0].showData.name || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("注册号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[0].showData.register_num || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("商标状态")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[0].showData.status || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("国际分类号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[0].showData.cat || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("申请时间")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[0].showData.date || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("专用权期限")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[0].showData.brandExpiredStart || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("商标代理机构")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[0].showData.agency || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("初审公告号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[0].showData.firstAuditNum || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("初审公告日期")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[0].showData.firstAuditDate || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("注册公告号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[0].showData.annNum || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("申请人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[0].showData.regName || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("申请地址")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[0].showData.regAddress || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("申请流程")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[0].showData.path || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("商品服务列表")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[0].showData.goods || "--"))])])])])]) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "专利信息详情",
      "visible": _vm.dialogData[1].show
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogData[1], "show", $event)
      }
    }
  }, [(_vm.dialogData[1].showData) ? _c('div', {
    staticStyle: {
      "height": "70vh",
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "pure-table pure-table-bordered"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "140px",
      "background": "#F7F7F7"
    }
  }, [_vm._v("专利名称")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[1].showData.name || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("申请日")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[1].showData.date || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("申请号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[1].showData.number || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("公开日")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[1].showData.date_end || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("公开号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[1].showData.public_number || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("法律状态")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[1].showData.status || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("分类号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[1].showData.ipc || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("专利国际分类")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[1].showData.cat || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("专利代理机构")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[1].showData.agencyName || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("代理人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[1].showData.agentName || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("专利权人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[1].showData.applicantName || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("地址")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[1].showData.address || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("发明人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[1].showData.inventorName || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("摘要")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dialogData[1].showData.abs || "--"))])])])])]) : _vm._e()])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box5 box2_cc"
  }, [_c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("专利名称")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("申请日")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("申请号")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("公开（公布）号\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("最新法律状态")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("专利类型")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 width-50 text-bold",
    staticStyle: {
      "flex": "none"
    }
  }, [_vm._v("操作")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box5 box2_cc"
  }, [_c('div', {
    staticClass: "box5_text1 text-cut text-center",
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("\n          序号\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-center",
    staticStyle: {
      "font-weight": "600",
      "width": "15%"
    }
  }, [_vm._v("\n          申请日期\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-cut",
    staticStyle: {
      "font-weight": "600",
      "width": "15%"
    }
  }, [_vm._v("商标\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-cut",
    staticStyle: {
      "font-weight": "600",
      "width": "30%"
    }
  }, [_vm._v("\n          商标名称\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-cut",
    staticStyle: {
      "font-weight": "600",
      "width": "15%"
    }
  }, [_vm._v("\n          注册号\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-center",
    staticStyle: {
      "font-weight": "600",
      "width": "15%"
    }
  }, [_vm._v("\n          国际分类\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-cut",
    staticStyle: {
      "font-weight": "600",
      "width": "15%"
    }
  }, [_vm._v("\n          商标状态\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 width-100 text-bold",
    staticStyle: {
      "flex": "none"
    }
  }, [_vm._v("操作")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex justify-between align-center toptitle"
  }, [_c('div', {
    staticClass: "topleft"
  }, [_vm._v("软件著作权"), _c('span', {
    staticClass: "rinum"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box5 box2_cc"
  }, [_c('div', {
    staticClass: "box5_text1 text-cut text-center",
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("\n          序号\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-cut",
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("登记批准日期")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-cut",
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("软件全称")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-cut",
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("软件简称")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-cut",
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("登记号")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-cut",
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("分类号")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-center",
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("版本号")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-center",
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("首次发表日期\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex justify-between align-center toptitle"
  }, [_c('div', {
    staticClass: "topleft"
  }, [_vm._v("作品著作权"), _c('span', {
    staticClass: "rinum"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box5 box2_cc"
  }, [_c('div', {
    staticClass: "box5_text1 text-cut text-center",
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("\n          序号\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-cut",
    staticStyle: {
      "font-weight": "600",
      "width": "22.5%"
    }
  }, [_vm._v("\n          作品名称\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-cut",
    staticStyle: {
      "font-weight": "600",
      "width": "22.5%"
    }
  }, [_vm._v("\n          登记号\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-cut",
    staticStyle: {
      "font-weight": "600",
      "width": "22.5%"
    }
  }, [_vm._v("\n          作品类别\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-cut",
    staticStyle: {
      "font-weight": "600",
      "width": "22.5%"
    }
  }, [_vm._v("\n          创作完成日期\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-cut",
    staticStyle: {
      "font-weight": "600",
      "width": "22.5%"
    }
  }, [_vm._v("\n          登记日期\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-cut",
    staticStyle: {
      "font-weight": "600",
      "width": "22.5%"
    }
  }, [_vm._v("\n          首次发表日期\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-721613c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/company/components/intellectual-page.vue
// module id = 899
// module chunks = 1